import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, PLATFORM_ID, inject } from "@angular/core";
import { NgxPermissionsService } from "ngx-permissions";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Systemuser } from "../models/systemuser.verifyEmail";
import { RoleService } from "./role.service";
import { HomePageService } from "src/app/Customer/services/home-page.service";
import { REQUEST } from "../../../express.tokens";
import { isPlatformServer } from "@angular/common";
import { otpModel } from "src/app/Shared/models/otp-model.model";
import { currentUser } from "../models/currentUser";
import { InitializationService } from "src/utils/initialization.service";
@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  private http = inject(HttpClient);
  private permissionsService = inject(NgxPermissionsService);
  private rolesService = inject(RoleService);
  private homePageService = inject(HomePageService);
  private intializationService = inject(InitializationService);
  private platformId = inject(PLATFORM_ID);
  private request = inject(REQUEST, { optional: true })!;
  apiUrl = environment.apiUrl;
  public currentUser: Observable<currentUser>;
  // public currentUserSubject: BehaviorSubject<any>
  public user: BehaviorSubject<any>;
  public emailOrPhone = {
    email: "",
    number: 0,
  };
  //  adTokenSubject: BehaviorSubject<string | null> = JSON.parse(
  //     localStorage.getItem("currentUser")
  //   )?.adToken;
  // loadPermissions(accessToken?: string) {
  //   // open when roles are available in token
  //   this.homePageService.configurations.token = accessToken;
  //   const roles = this.rolesService.getDecodedTokenInfo(accessToken).roles;
  //   this.homePageService.siteCatalog = this.intializationService?.getSiteCatalogFromToken(accessToken)
  //   this.homePageService!.role = roles[0];
  //   if (roles?.length) {
  //     this.permissionsService.loadPermissions(roles); //loaded to ngx permissions
  //   }
  // }
  private adTokenSubject = new BehaviorSubject<string | null>(
    JSON.parse(localStorage.getItem("currentUser") || "{}")?.adToken ?? null
  );

  adToken$ = this.adTokenSubject.asObservable();

  setAdToken(token: string | null) {
    this.adTokenSubject.next(token);
  }
  getPermissions() {
    return this.permissionsService.permissions$;
  }
  removePermissions() {
    this.permissionsService.flushPermissions();
  }
  getCurrentUrl(): string {
    if (isPlatformServer(this.platformId)) {
      // If SSR, get the URL from the request object
      return this.request.hostname;
    } else {
      // If browser, get the URL from the location service
      return window.location.host;
      // return 'devcms.indisell.com'
    }
  }
  Login(model: any) {
    //No need
    let baseUrl: string = environment.production
      ? this.getCurrentUrl()
      : environment.baseUrl;
    model.baseUrl = baseUrl;
    return this.http.post(`${this.apiUrl}Accounts/SystemUser/Login`, model);
  }
  // getCurrentUser(): User {
  //   /*Getting the current user from localStorage to handle the case where user opened two tabs and logged in in one.*/
  //   const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  //   this.intializationService.currentUserSubject.next(currentUser);
  //   return currentUser;
  // }
  getUser(): currentUser | null {
    // this.user = this.currentUserSubject.value;
    return this?.intializationService.currentUserSubject?.value;
  }
  removeCurrentUser() {
    this?.intializationService.SetHeader.next(false);
    this.removePermissions();
    localStorage.removeItem("systemUser");
    localStorage.removeItem("currentUser");
    this.intializationService.currentUserSubject.next(null);
  }

  getSystemUser() {
    return this.http.get(`${this.apiUrl}Accounts/SystemUser`);
  }
  getSystemUserBySystemUser(systemUser) {
    if (systemUser == null) {
      return this.http.get(`${this.apiUrl}Accounts/SystemUser`);
    } else {
      return this.http.get(
        `${this.apiUrl}Accounts/SystemUser?systemUser=${systemUser}`
      );
    }
  }
  getSystemUserForAdmin(systemUser) {
    return this.http.get(
      `${this.apiUrl}Accounts/SystemUser?systemUser=${systemUser}`
    );
  }
  updateSystemUser(updateSystemUserModel: any) {
    return this.http.put(
      `${this.apiUrl}Accounts/SystemUser`,
      updateSystemUserModel
    );
  }

  SendOtp(model: otpModel) {
    let baseUrl: string = environment.production
      ? this.getCurrentUrl()
      : environment.baseUrl;
    model.baseUrl = baseUrl;
    return this.http.post(
      `${this.apiUrl}Accounts/SystemUser/LoginWithOtp?CellPhone=${model.cellphone}&BaseUrl=${baseUrl}`,
      null
    );
  }
  VerifyOtp(model: any) {
    const otpModel = {
      cellPhone: model.emailOrPhone,
      otpCode: model.otpCode,
      role: model.role,
    };
    return this.http.post(
      `${this.apiUrl}Accounts/SystemUser/VerifyOtp`,
      otpModel
    );
  }
  VerifyEmailSystemUser(model: any) {
    let params = new HttpParams();
    params = params.append("EmailAddress", model?.emailAddress);
    let baseUrl: string = this.getCurrentUrl();
    params = params.append("baseUrl", baseUrl);
    return this.http.get<Systemuser>(
      `${this.apiUrl}Accounts/SystemUser/VerifyEmail`,
      { params: params }
    );
  }
  getNumber() {
    return this.emailOrPhone;
  }
  RegisterVendorAsCustomer() {
    return this.http.post(
      `${this.apiUrl}Accounts/RegisterVendorAsCustomer`,
      {}
    );
  }
  switchRoles(user) {
    return this.http.post(`${this.apiUrl}Accounts/SwitchRoles`, user);
  }
  adminLoginAsWholesaler(model: any) {
    return this.http.post(
      `${this.apiUrl}Accounts/AdminLoginAsWholesaler`,
      model
    );
  }
}
